module.exports = __webpack_public_path__ + "statics/img/cate7-2@2x.68ece3ff.png";